import trackers from 'beekin-analytics';

class trackerClass {
    constructor() {
        if (!trackerClass.instance) {
            this.tracker = trackers;
            trackerClass.instance = this;
        }

        return trackerClass.instance;
    }
}

const tracker = new trackerClass();
Object.freeze(tracker);

export const getTracker = () => {
    return tracker.tracker;
}